import { render } from "./excelTextView.vue?vue&type=template&id=4acafaf2"
import script from "./excelTextView.vue?vue&type=script&lang=js"
export * from "./excelTextView.vue?vue&type=script&lang=js"
script.render = render

export default script